import styled, { ITheme } from '../../../theme'

const StandardRowWrapper = styled.div`
  clear: both;
  padding-top: 18px;
`

const StandardLabel = styled.label`
  float: left;
  font-size: 14px;
  color: #696a6d;
  line-height: 37px;
  width: 50%;
  font-weight: 500;
`

const StandardInput = styled.input`
  float: right;
  height: 35px;
  line-height: 35px;
  padding-left: 10px;
  width: 50%;
  max-width: 367px;
  border: 1px solid ${(props: ITheme) => props.theme.colors.border};
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  color: ${(props: ITheme) => props.theme.colors.palette.darkGreyTwo};
  font-weight: 500;
  &::-webkit-input-placeholder {
    color: ${(props: ITheme) => props.theme.colors.placeholder};
  }
  &::-moz-placeholder {
    color: ${(props: ITheme) => props.theme.colors.placeholder};
  }
  &:-ms-input-placeholder {
    color: ${(props: ITheme) => props.theme.colors.placeholder};
  }
  &:-moz-placeholder {
    color: ${(props: ITheme) => props.theme.colors.placeholder};
  }
`

export { StandardRowWrapper, StandardLabel, StandardInput }
